import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiCheck, FiInfo, FiCalendar } from 'react-icons/fi';
import PageTransition from '../components/PageTransition';
import SafeIcon from '../common/SafeIcon';
import AvailabilityCalendar from '../components/Calendar/AvailabilityCalendar';
import ncb from '../db/ncb';

const Rates = () => {
  const [blockedDates, setBlockedDates] = useState([]);

  useEffect(() => {
    const data = ncb.availability.list();
    setBlockedDates(data.map(d => ({ start: d.date, end: d.date })));
  }, []);

  return (
    <PageTransition>
      <div className="bg-brand-olive pt-20 pb-24 text-center px-4 text-brand-cream">
        <span className="font-script text-3xl text-brand-light mb-2 block">Plan Your Stay</span>
        <h1 className="font-serif text-4xl md:text-5xl uppercase tracking-widest">Rates & Availability</h1>
      </div>

      <div className="container mx-auto px-6 max-w-7xl py-16">
        <div className="grid lg:grid-cols-3 gap-12 items-start">
          <div className="lg:col-span-1 space-y-8">
            <div className="bg-white rounded-sm shadow-xl overflow-hidden border border-brand-light/30 sticky top-28">
              <div className="bg-brand-dark text-center py-6">
                <h2 className="font-serif text-2xl text-brand-cream">Apartelle Suite</h2>
              </div>
              <div className="p-8 text-center">
                <div className="mb-8 pb-8 border-b border-brand-light/20">
                  <div className="flex items-center justify-center font-serif text-brand-olive">
                    <span className="text-3xl mr-1">₱</span>
                    <span className="text-5xl font-bold">2,500</span>
                    <span className="text-xl text-brand-sage ml-2 self-end mb-1">/ night</span>
                  </div>
                </div>
                <Link to="/contact" className="block w-full bg-brand-olive text-brand-cream py-4 uppercase tracking-[0.2em] text-xs font-bold hover:bg-brand-dark transition-all shadow-lg">
                  Inquire Now
                </Link>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="mb-8">
              <h3 className="font-serif text-3xl text-brand-dark flex items-center gap-3">
                <SafeIcon icon={FiCalendar} className="text-brand-olive" /> Availability
              </h3>
            </div>
            <AvailabilityCalendar bookedDates={blockedDates} />
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default Rates;